module.exports = __webpack_public_path__ + "static/media/development_design_cropped.5742fbb7.png";